import { Button, ButtonGroup } from '@vds/buttons';
import { Icon } from '@vds/icons';
import { TileContainer } from '@vds/tiles';
import { Body, Title } from '@vds/typography';
import React, { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect';
import { decodeHTML, formatEventTime, navigateUsingLanguage, getTimeZoneAbbreviation, replaceDate } from '../../../utility/utils';
import { Register_Event } from '../../../common/Analytics/GAWrapper';
import { useTranslation } from 'react-i18next';


const InPersonEventWidget = ({ eventCxAemData, currentEvent }) => {
  const [isBefore, setIsBefore] = useState(false);
  const [isAfter, setIsAfter] = useState(false);
  const [widgetTitle, setWidgetTitle] = useState('');
  const [widgetSubtitle, setWidgetSubtitle] = useState('');
  const [deadlineUpcoming, setDeadlineUpcoming] = useState(false);
  const [lastDay, setLastDay] = useState(false);
  const [deadlinePassed, setDeadlinePassed] = useState(false);
  const [eventInProgress, setEventInProgress] = useState(false);
  const warningMessages = [];
  const [updatedCiamSignInURL, setupdatedCiamSignInURL] = useState('');
  const dateTimeFormat = formatEventTime(currentEvent, currentEvent?.modules?.[0]?.inPersonLocation?.timeZone?.zone,true);
  const dateTimeString = new Date(new Date(currentEvent?.enrollmentDeadline).toString())
  let timeZone = getTimeZoneAbbreviation(dateTimeString, currentEvent?.modules?.[0]?.inPersonLocation?.timeZone?.zone);
  const formatter = new Intl.DateTimeFormat('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
  const parts = formatter.formatToParts(currentEvent?.enrollmentDeadline);
  const hour = parts.find((part) => part.type === 'hour').value;
  const minute = parts.find((part) => part.type === 'minute').value;
  const ampm = parts.find((part) => part.type === 'dayPeriod').value;
  const options = { month: "short", day: "numeric" }
  const datePart = dateTimeString.toLocaleDateString("en-US", options);

  let lng = localStorage.getItem("lng") && localStorage.getItem("lng") === 'es' ? 'es' : 'en';
  let userLanguageTitle = currentEvent?.localizeData?.filter(e => e.locale.indexOf(lng) != -1);
  let resourceTitle = currentEvent?.title;
  if (userLanguageTitle.length > 0) {
    resourceTitle = userLanguageTitle[0].name;
  }
  const { t } = useTranslation();
  const level = currentEvent?.skills?.[0]?.level ?? "";
  const skillCategory = currentEvent?.skills?.[0]?.name ?? "";
  const admissionCost = currentEvent?.localizeData?.[0]?.pricingInfo?.cost;
  const formattedAdmissionCost = admissionCost && admissionCost.toString().trim().toLowerCase() !== "free" ? t("paid") : t("free");


  if (isBefore && lastDay) {
    warningMessages.push(<div key="lastDay" className='n-displayFlex mb-2X'><Icon size='small' name='warning' /><div className='ml-2X'><Body size='medium'>{decodeHTML(eventCxAemData?.widgetMsg?.enrollLastDate)}</Body></div></div>);
  } else if (isBefore && deadlineUpcoming) {
    warningMessages.push(<div key="deadlineUpcoming" className='n-displayFlex mb-2X'><Icon size='small' name='warning' /><div className='ml-2X'><Body size='medium'>{decodeHTML(replaceDate(eventCxAemData?.widgetMsg?.enrollByDate, currentEvent?.enrollmentDeadline))}</Body></div></div>);
  }
  const settingFilterForCategoryPage = () => {
    localStorage.setItem('find_event_filter', JSON.stringify({
      tags: currentEvent?.tags,
      skills: currentEvent?.skills,
      language: currentEvent?.locale
    }));
    navigateUsingLanguage("/category/inpersonevents");
  }

  useEffect(() => {
    if (isBefore) {
      setWidgetTitle(dateTimeFormat);
      setWidgetSubtitle(decodeHTML(eventCxAemData?.widgetMsg?.enrollOpenText));
      if (deadlineUpcoming || lastDay) {
        setWidgetTitle(dateTimeFormat);
        setWidgetSubtitle(decodeHTML((eventCxAemData?.widgetMsg?.enrollBeforeTxt)?.replace("[date]", datePart)?.replace("[time]", `${hour}:${minute} ${ampm} ${timeZone}`)));
      }
      else if (deadlinePassed) {
        setWidgetTitle(decodeHTML(eventCxAemData?.widgetMsg?.enrollDlMsg));
        setWidgetSubtitle("");
      }
    }
     else if (isAfter) {
      setWidgetTitle(decodeHTML(eventCxAemData?.widgetMsg?.eventEndedMsg));
      setWidgetSubtitle("");
    }
    else if (eventInProgress) {
      setWidgetTitle(decodeHTML(eventCxAemData?.widgetMsg?.eventInprogressMsg));
      setWidgetSubtitle("");
    }
  }, [isBefore, isAfter, lastDay, deadlineUpcoming, eventInProgress, deadlinePassed, lastDay]);

  useEffect(() => {
    const tillTime = Date.now();
    const endTime = currentEvent?.dateEnd > 0 ? currentEvent?.dateEnd :(currentEvent?.dateStart + (currentEvent?.duration * 1000));
    if (currentEvent?.dateStart > tillTime) {
      setIsBefore(true);
      if (currentEvent?.enrollmentDeadline !== null) {
        if (((currentEvent?.enrollmentDeadline - (24 * 60 * 60 * 1000)) <= tillTime) && (tillTime <= currentEvent?.enrollmentDeadline)) {
          setLastDay(true);
        }
        else if (((currentEvent?.enrollmentDeadline - (5 * 24 * 60 * 60 * 1000)) <= tillTime) && (tillTime <= currentEvent?.enrollmentDeadline)) {
          setDeadlineUpcoming(true);
        }
        if (currentEvent?.enrollmentDeadline < tillTime) {
          setDeadlinePassed(true);
        }
      }
    }
    else if ((endTime) >= tillTime) {
      setEventInProgress(true);
    }
    else if ((endTime) < tillTime) {
      setIsAfter(true);
    }
    if (window?.location?.search?.includes('utm_')) {
      const utmUrl = `${window?.location?.search?.substring(1)}`;
      localStorage.setItem('utmUrl', utmUrl);
      setupdatedCiamSignInURL(`${eventCxAemData?.regBannerButtons?.signInLink}/course-details/${currentEvent?.id}?ciamLang=${lng}&${utmUrl}`);
    } else {
      if (localStorage.getItem('utmUrl')) {
        setupdatedCiamSignInURL(`${eventCxAemData?.regBannerButtons?.signInLink}/course-details/${currentEvent?.id}?ciamLang=${lng}&${localStorage.getItem('utmUrl')}`);
      } else {
        console.log('dfdfd', lng)
        setupdatedCiamSignInURL(`${eventCxAemData?.regBannerButtons?.signInLink}/course-details/${currentEvent?.id}?ciamLang=${lng}`);
      }
    }
  }, [currentEvent])

  useEffect(() => {
    const now = new Date();
    const eventTime = new Date(currentEvent?.dateStart);
    const timer = eventTime.getTime() - now.getTime();

    if (timer < (5 * 3600000) && timer > 0) {
      const timerId = setTimeout(() => {
        window.location.reload(true);
      }, timer);

      return () => {
        clearTimeout(timerId);
      };
    }
  }, [currentEvent?.dateStart])

  return (
    <>
      <TileContainer
        padding='24px'
        aspectRatio='none'
        width='100%'
        // height='100%'
        backgroundColor='rgba(243, 237, 224, 1)'
      >
        <div className={isBefore ? '' : 'widget-container'}>

          <div className='width-100'>
            {warningMessages.map((msg, idx) =>
              idx === warningMessages.length - 1
                ? React.cloneElement(msg, { className: msg.props.className + ' mb-4X' })
                : msg
            )}
            <Title size={isMobile ? 'medium' : 'small'} bold>{widgetTitle}</Title>
            <div className='mt-2X'><Body size='large'>{widgetSubtitle}</Body></div>
            <div className='mt-6X n-displayFlex n-alignItemCenter'>
              {(isBefore && !deadlinePassed) && <ButtonGroup
                childWidth={'100%'}
                viewport={'desktop'}
                rowQuantity={{ desktop: 2 }}
                data={[
                  {
                    children: decodeHTML(eventCxAemData?.regBannerButtons?.regButtonText),
                    size: 'large',
                    use: 'primary',
                    width: 'auto',
                    onClick: () => {
                      location.href = eventCxAemData?.regBannerButtons?.regLink
                    },
                  },
                  {
                    children: decodeHTML(eventCxAemData?.regBannerButtons?.signInText),
                    size: 'large',
                    use: 'textLink',
                    width: 'auto',
                    onClick: () => {
                      Register_Event(resourceTitle, skillCategory, level, formattedAdmissionCost, `${t("Event")}: ${t("In-Person Event")}`);
                      location.href = updatedCiamSignInURL
                    },
                  },

                ]}
                alignment={'left'}
              />}

              {(deadlinePassed || eventInProgress || isAfter) && <ButtonGroup
                childWidth={'100%'}
                viewport={'desktop'}
                rowQuantity={{ desktop: 2 }}
                data={[
                  {
                    children: decodeHTML(eventCxAemData?.widgetMsg?.similarEventTxt),
                    size: 'large',
                    use: 'primary',
                    width: 'auto',
                    onClick: () => {
                      settingFilterForCategoryPage()
                    },
                  }
                ]}
                alignment={'left'}
              />}

            </div>
            {(isBefore && !deadlinePassed) && <div className='mt-8X'>
              <Body size='medium'>{decodeHTML(eventCxAemData?.widgetMsg?.regWidgetMsg)}</Body>
            </div>}
          </div>
        </div>
      </TileContainer>
    </>
  )
}

export default InPersonEventWidget